import { HealthStatusEntry } from '../model/healthStatus';
import { TkvAngabenV2Item } from '../reducer/tkvAngabenV2.reducer';
import { StatePreV24, StateV24 } from './24_migrate_diagnosis_label.interface';

const DIAGNOSIS_LABEL_CORRECTIONS: [string, string][] = [
  ['Verenkung der Kniescheibe (Patellaluxation)', 'Verrenkung der Kniescheibe (Patellaluxation)'],
  ['Osteochondrosis dissecans (OCD)', 'Osteochondrosis dissecans (OCD) / Gelenkchips'],
];

const correctDiagnosisLabel = (diagnosis: string | null): string | null => {
  if (!diagnosis) {
    return diagnosis;
  }
  return DIAGNOSIS_LABEL_CORRECTIONS.reduce(
    (result, [oldLabel, newLabel]) => result.split(oldLabel).join(newLabel),
    diagnosis,
  );
};

const migrateHealthStatusEntries = (entries: HealthStatusEntry[] | undefined): HealthStatusEntry[] | undefined => {
  return entries?.map(entry => ({
    ...entry,
    diagnosis: correctDiagnosisLabel(entry.diagnosis),
  }));
};

const migrateAngabenItems = (items: TkvAngabenV2Item[]): TkvAngabenV2Item[] => {
  return items?.map(item => ({
    ...item,
    healthStatusEntries: migrateHealthStatusEntries(item.healthStatusEntries),
    previousHealthStatusEntries: migrateHealthStatusEntries(item.previousHealthStatusEntries),
  }));
};

export const migrateDiagnosisLabel = (previousState: StatePreV24, newVersion: number): StateV24 => {
  return {
    ...previousState,
    version: newVersion,
    tkvAngabenV2: previousState.tkvAngabenV2
      ? {
          ...previousState.tkvAngabenV2,
          angabenItems: migrateAngabenItems(previousState.tkvAngabenV2.angabenItems),
        }
      : previousState.tkvAngabenV2,
  };
};
